// Google Calendar on a Team directory card. All behavior lives in
// CalendarConnectBadge, shared with OutlookConnectBadge so the two can never
// drift apart (connect, read-only state, and Disconnect on your own card).
import React from "react";
import CalendarConnectBadge from "./CalendarConnectBadge";

export default function GoogleConnectBadge(props) {
  return <CalendarConnectBadge {...props} provider="google" label={props.label || "Google"} />;
}
